module.exports = __webpack_public_path__ + "static/home3-cf638726ef85b3094479a72a8d69678f.jpg";